import classNames from 'classnames';

import type { Environment } from './../ricos-types';

import styles from './statics/styles/style-presets-scss';

export const getStyles = (environment: Environment, isMobile: boolean): string | null =>
  classNames({
    [styles.liveSite]: environment === 'liveSite',
    [styles.businessManager]: environment === 'businessManager',
    [styles.mobile]: isMobile,
  });
